import { z } from 'zod';
const searchFlightsSegmentSchema = z.object({
    category: z.enum(['airport', 'city']),
    iataCode: z.string().min(1).max(16),
});
/**
 * Corps des recherches de vols (`POST /research_bar/search` et
 * `POST /chat/flight/search`). Le payload est ensuite recopié tel quel dans la
 * requête au GDS : on vérifie la forme, sans contrainte métier — les dates
 * restent des chaînes libres (le service les normalise) et les compteurs de
 * passagers sont simplement des entiers positifs, comme le formulaire web les
 * produit déjà.
 */
export const searchFlightsSchema = z.object({
    flights: z
        .array(z.object({
        date: z.string().min(1),
        departure: searchFlightsSegmentSchema,
        destination: searchFlightsSegmentSchema,
    }))
        .min(1),
    passengers: z.object({
        adults: z.number().int().min(0),
        babies: z.number().int().min(0),
        infants: z.number().int().min(0),
        seniors: z.number().int().min(0),
        youngsters: z.number().int().min(0),
    }),
    travelClass: z.enum(['BUSINESS', 'ECONOMY', 'PREMIUM']),
    withLuggage: z.boolean().optional(),
});
